export default "__VITE_ASSET__QyntmdZ1__"